exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pricing p{margin-bottom:4px;margin-top:-20px}@media screen and (max-width: 950px){.pricing p{margin:10px}}.pricing table{width:100%;max-width:100vw;margin-bottom:40px;border:none}.pricing tbody tr:nth-child(odd){background-color:rgba(0,0,0,0.06)}@media screen and (max-width: 950px){.pricing{overflow-y:scroll}}.pricing th{text-align:center;width:100%;font-weight:300;padding-bottom:10px}.pricing td{padding:14px 20px;margin:0;text-align:right}.pricing td:first-child{text-align:left}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Pricing/Pricing.scss
// module id = 312
// module chunks = 0